import React from 'react';
import {  Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from './auth'; // Make sure isAuthenticated checks the user's authentication status

const ProtectedRoute = () => {
    return isAuthenticated() ? (<Outlet />) : <Navigate to="/" />;
};

export default ProtectedRoute;